<template>
  <form @submit.prevent="$emit('submit')">
    <div class="form-field">
      <label for="login-email">Email</label>

      <input
        id="login-email"
        :value="email"
        type="email"
        name="email"
        placeholder="nama@email.com"
        autocomplete="email"
        required
        :disabled="loading"
        @input="$emit('update:email', $event.target.value)"
      />
    </div>

    <div class="form-field">
      <label for="login-password">Password</label>

      <div class="password-field">
        <input
          id="login-password"
          :value="password"
          :type="showPassword ? 'text' : 'password'"
          name="password"
          placeholder="Masukkan password"
          autocomplete="current-password"
          required
          :disabled="loading"
          @input="$emit('update:password', $event.target.value)"
        />

        <button
          class="password-toggle"
          type="button"
          :aria-label="
            showPassword
              ? 'Sembunyikan password'
              : 'Tampilkan password'
          "
          :disabled="loading"
          @click="showPassword = !showPassword"
        >
          <Icon
            :icon="
              showPassword
                ? 'mdi:eye-off-outline'
                : 'mdi:eye-outline'
            "
            width="20"
            height="20"
          />
        </button>
      </div>
    </div>

    <div class="login-options">
      <label class="remember-option">
        <input
          :checked="remember"
          type="checkbox"
          :disabled="loading"
          @change="$emit('update:remember', $event.target.checked)"
        />
        <span>Ingat saya</span>
      </label>

      <RouterLink to="/forgot-password">
        Lupa password?
      </RouterLink>
    </div>

    <button
      class="login-submit"
      type="submit"
      :disabled="loading"
    >
      <span v-if="loading">Memproses...</span>
      <span v-else>Masuk</span>
    </button>
  </form>
</template>

<script>
import { ref } from 'vue'
import { RouterLink } from 'vue-router'
import { Icon } from '@iconify/vue'

export default {
  name: 'LoginForm',

  components: {
    RouterLink,
    Icon
  },

  props: {
    email: {
      type: String,
      default: ''
    },
    password: {
      type: String,
      default: ''
    },
    remember: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  emits: [
    'submit',
    'update:email',
    'update:password',
    'update:remember'
  ],

  setup() {
    const showPassword = ref(false)

    return {
      showPassword
    }
  }
}
</script>
